import axios, { encodeData } from "../utils/axios";

export const fetchPrfcsTypes = async () => {
  const res = await axios.get("/prfcsTypes").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const createPrfcsType = async (newPrfcsType) => {
  await axios.post("/prfcsTypes/create", encodeData(newPrfcsType));
};

export const updatePrfcsType = async (updatedPrfcsType) => {
  await axios.put("/prfcsTypes/update", encodeData(updatedPrfcsType));
};

export const deletePrfcsType = async (oldPrfcsType) => {
  await axios.delete("/prfcsTypes/delete", { data: encodeData(oldPrfcsType) });
};
